import React from 'react';
import { Calendar, Users, Network, TrendingUp, Award, Target, Sparkles, Heart } from 'lucide-react';

const DiaDoAlumni = () => {
    const objectives = [
        {
            icon: <Users className="w-5 h-5" />,
            title: "Espírito de Colaboração",
            description: "Promover um espírito de colaboração entre os Alumni e a UEM, fortalecendo os laços institucionais."
        },
        {
            icon: <Network className="w-5 h-5" />,
            title: "Parcerias Estratégicas",
            description: "Buscar novas formas de parceria para a implementação de projectos e iniciativas de desenvolvimento institucional."
        },
        {
            icon: <TrendingUp className="w-5 h-5" />,
            title: "Networking e Orientação",
            description: "Proporcionar uma oportunidade para a criação de networking, orientação e colaboração entre os Alumni e estudantes."
        }
    ];

    const keyDates = [
        {
            date: "14 de Junho",
            title: "Dia Oficial do Alumni",
            description: "Data oficial decretada pela UEM para celebração em todas as unidades académicas."
        }
    ];

    return (
        <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
            {/* Header Section */}
             <div className="mb-12 bg-emerald-50 rounded-xl p-6 border border-emerald-100/50">
                <div className="border-l-4 border-emerald-500 pl-4 mb-4">
                    <h1 className="text-3xl font-bold text-gray-800 tracking-tight">Dia do Alumni</h1>
                    <p className="text-gray-500 text-base font-light mt-1">
                        Celebração anual da comunidade de graduados da Universidade Eduardo Mondlane
                    </p>
                </div>
            </div>

            {/* Hero Section */}
            <div className="bg-gradient-to-r from-emerald-50/50 to-gray-50/50 rounded-xl p-8 mb-10 border border-emerald-100/30">
                <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 rounded-full bg-emerald-100 flex items-center justify-center">
                        <Calendar className="w-5 h-5 text-emerald-600" />
                    </div>
                    <h2 className="text-2xl font-light text-gray-700">14 de Junho</h2>
                </div>
                <p className="text-gray-600 leading-relaxed">
                    A UEM decretou o dia <span className="font-medium text-emerald-600">14 de Junho</span> como o <span className="font-medium">Dia do Alumni na UEM</span>, 
                    que deve ser celebrado todos os anos em todas as unidades académicas. A celebração é uma oportunidade 
                    para os Alumni estarem sempre informados e associados aos desafios da Universidade, às suas actividades, 
                    aos eventos, aos programas de ensino, pesquisa e extensão, ao desenvolvimento de infraestruturas, 
                    bibliotecas, instalações culturais e esportivas, museus e serviços.
                </p>
            </div>

            {/* Objectives Section */}
            <div className="mb-12">
                <div className="flex items-center gap-2 mb-6">
                    <Target className="w-5 h-5 text-emerald-500" />
                    <h2 className="text-lg font-medium text-gray-700">Objectivos da Celebração</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {objectives.map((objective, index) => (
                        <div 
                            key={index}
                            className="bg-white rounded-xl border border-gray-100 p-6 hover:shadow-md transition-all duration-300 group"
                        >
                            <div className="flex justify-center mb-4">
                                <div className="w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
                                    <div className="text-emerald-600">
                                        {objective.icon}
                                    </div>
                                </div>
                            </div>
                            <h3 className="text-base font-medium text-gray-800 text-center mb-2">
                                {objective.title}
                            </h3>
                            <p className="text-gray-500 text-center text-sm leading-relaxed">
                                {objective.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Impact Section */}
            <div className="bg-gray-50/50 rounded-xl p-6 border border-gray-100 mb-10">
                <div className="flex items-center gap-2 mb-5">
                    <Award className="w-5 h-5 text-emerald-500" />
                    <h2 className="text-base font-medium text-gray-700">Impacto e Benefícios</h2>
                </div>
                <div className="flex flex-row justify-around items-center">
                    <div className="text-center">
                        <div className="text-2xl font-light text-emerald-600">+500</div>
                        <div className="text-xs text-gray-400 mt-1">Alumni Participantes</div>
                    </div>
                    <div className="w-px h-8 bg-gray-200"></div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-emerald-600">10+</div>
                        <div className="text-xs text-gray-400 mt-1">Unidades Académicas</div>
                    </div>
                    <div className="w-px h-8 bg-gray-200"></div>
                    <div className="text-center">
                        <div className="text-2xl font-light text-emerald-600">Anual</div>
                        <div className="text-xs text-gray-400 mt-1">Celebração Contínua</div>
                    </div>
                </div>
            </div>

            {/* Call to Action Section */}
            <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-xl p-8 text-center mb-10">
                <div className="flex justify-center mb-4">
                    <Heart className="w-8 h-8 text-white/80" />
                </div>
                <h3 className="text-xl font-light text-white mb-2">
                    Participe do Dia do Alumni
                </h3>
                <p className="text-emerald-100 text-sm mb-6">
                    Junte-se à comunidade de graduados e faça parte desta celebração especial
                </p>
                <button 
                    onClick={() => window.location.href = "/contactos"}
                    className="bg-white text-emerald-600 px-6 py-2 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors shadow-sm"
                >
                    Saiba mais
                </button>
            </div>

            {/* Key Dates Section */}
            <div className="pt-6 border-t border-gray-100">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    {keyDates.map((item, index) => (
                        <div key={index} className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-emerald-50 flex items-center justify-center">
                                <Calendar className="w-4 h-4 text-emerald-500" />
                            </div>
                            <div>
                                <div className="text-sm font-medium text-gray-700">{item.date}</div>
                                <div className="text-xs text-gray-400">{item.title}</div>
                            </div>
                        </div>
                    ))}
                    <div className="text-xs text-gray-400">
                        *Celebrado anualmente em todas as unidades académicas
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiaDoAlumni;